var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.theme)?_c('div',{staticClass:"wrap",class:{ [_vm.$store.state.theme.buttonStyle]: true }},[_c('button',{staticClass:"main_button",on:{"click":_vm.hanldeClick,"mouseenter":_vm.hanldeHover}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }